/**
 * @module meeting
 */

module.exports = function (config, get, post) {

    function getMeeting(meetingId) {
        return get(`/v2/meetings/${meetingId}`);
    }

    function leaveMeeting(meetingId) {
        return post(`/v2/meetings/${meetingId}/leave`);
    }

    function createMeeting(title, description, administrators, participants, recipient) {
        return post(`/v2/meetings`, {
            title,
            description,
            participants,
            recipient,
            administrators,
        });
    }

    function inviteToMeeting(meetingId, invitee) {
        return post(`/v2/meetings/${meetingId}/invite`, { invitee });
    }

    function joinMeeting(meetingId) {
        return post(`/v2/meetings/${meetingId}/join`);
    }

    return {
        getMeeting,
        joinMeeting,
        leaveMeeting,
        createMeeting,
        inviteToMeeting,
    };
};